<template>
  <teleport to="body">
    <vue-easy-lightbox :visible="visible" :imgs="imgs" :index="index" @hide="handleHide"></vue-easy-lightbox>
  </teleport>
  <PageTitle :title="content.khayatsPersonalGallery" :parentTitle="content.about">
    <YearDropdown @setYear="setYear"></YearDropdown>
  </PageTitle>
  <div v-if="noResult" class="font-xl layout-padding">
    {{ content.noResultFound }}
  </div>
  <div>
    <div class="masonry layout-padding">
      <div v-for="(img, index) in personalPhotos" class="mItem relative" :key="index" :id="`personal-photo-${index}`" @click="showImgs(img?.image)">
        <div class="
            w-full
            h-full
            absolute
            left-0
            top-0
            personal-img-overlay
            z-[1]
            flex flex-col
            justify-between
            items-center
          " :id="`overlay-${index}`">
          <div></div>
          <div class="relative">
            <div class="w-[1px] h-[90px] border-l top-[-45px] left-[45px] absolute"></div>
            <div class="w-[90px] h-[1px] border-t"></div>
          </div>
          <div class="text-white font-base pb-5 px-5 text-center">
            {{ img.description }} , {{ content.year }} {{ img?.date.substring(0, 4) }}
          </div>
        </div>
        <img :src="img?.image" />
      </div>
    </div>
    <div class="w-full flex justify-center my-8">
      <div @click="loadData" v-if="!allPhotosLoaded" class="
          py-4
          px-10
          bg-primary
          w-max
          text-center
          transition-all
          duration-700
          hover:bg-secondary
          cursor-pointer
          min-w-[216px]
        ">
        {{ content.loadMore }}
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
export default {
  data() {
    return {
      selectedYear: null,
      oldLength: 0,
            imgs: [],
      visible: false,
      index: 0, // default: 0,
    };
  },
  methods: {
    parallex() {
      for (
        let index = this.oldLength;
        index < this.personalPhotos?.length - 1;
        index++
      ) {
        if (index % 2 == 0) {
          gsap.to(`#personal-photo-${index}`, {
            translateY: "-20%",
            scrollTrigger: {
              trigger: `#personal-photo-${index}`,
              start: "top 150",
              end: "500",
              scrub: 1,
              id: index,
            },
          });
        } else {
          gsap.to(`#personal-photo-${index}`, {
            translateY: "-25%",
            scrollTrigger: {
              trigger: `#personal-photo-${index}`,
              start: "top 130",
              end: "500",
              scrub: 1,
              id: index,
            },
          });
        }
      }
    },
    handleHide() {
      this.visible = false;
    }, 
    showImgs(img) {
      this.imgs = img;
      this.visible = true;
    },
    setYear(year) {
      this.selectedYear = year;
    },

    async loadData() {
      await this.$store.dispatch("about/personalPhotos", {
        year: this.selectedYear,
      });
      await this.parallex();
      this.oldLength = await this.personalPhotos.length;
    },
  },
  inject: ["content"],

  computed: {
    personalPhotos() {
      return this.$store.getters["about/personalPhotos"];
    },
    allPhotosLoaded() {
      return this.$store.getters["about/allPhotosLoaded"];
    },
    noResult() {
      return this.$store.getters["about/noResult"];
    },
  },
  watch: {
    selectedYear() {
      this.$store.dispatch("about/resetPhotos");
      this.loadData();
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style scoped>
img {
  width: 100%;
}

.masonry {
  /*column-count: 4;*/
  column-count: 3;
  column-gap: 50px;
}

.masonry .mItem {
  display: inline-block;
  margin-bottom: 50px;
  width: 100%;
}

@media (max-width: 1199px) {
  .masonry {
    column-count: 3;
  }
}

@media (max-width: 991px) {
  .masonry {
    column-count: 2;
  }
}

@media (max-width: 767px) {
  .masonry {
    column-count: 1;
  }
}
</style>

